import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useCollection } from '../hooks/useCollection'
import ReactAudioPlayer from 'react-audio-player'
import parse from 'html-react-parser'

// styles
import './Kaiwa.css'

// metadata
import { TopicMetadata } from '../metadata/TopicMetadata'
import { KaiwaMetadata } from '../metadata/KaiwaMetadata'

const getKaiwaId = (segment) => segment.split('-')[0]

export default function Kaiwa() {
    const { id } = useParams()

    const [kakariState, setKakariState] = useState(true)
    const [teidaiState, setTeidaiState] = useState(true)
    const [kakuState, setKakuState] = useState(true)
    const [sentenceFinalState, setSentenceFinalState] = useState(true)
    const [setsuzokuState, setSetsuzokuState] = useState(true)
    const [juntaiState, setJuntaiState] = useState(true)

    const { documents: data, error } = useCollection('corpus-v2', ["kaiwa_segment", "==", id])

    let mp3_src = process.env.PUBLIC_URL + '/audio/' + id + '.mp3'

    if (error) {
        return <p>{error}</p>
    }

    if (!TopicMetadata[id] || !KaiwaMetadata[getKaiwaId(id)]) {
        return <p>Not found!</p>
    }

    return (
        <div className='container'>
            <div className='kaiwa-title container-md'>
                <h3 className="text-center">{id}</h3>
                <h4 className='text-center'>{TopicMetadata[id]}</h4>
                <div className='row justify-content-center'>
                    <h6 className='col- text-center'>{KaiwaMetadata[getKaiwaId(id)].date} - {KaiwaMetadata[getKaiwaId(id)].location}</h6>
                </div>
            </div>
            <div className='highlight-checkboxes container-md'>
                <div className='row justify-content-between mb-1'>
                    <div className='col-md-auto my-auto'>
                        <ReactAudioPlayer src={mp3_src} controls={true} />
                    </div>
                    <div className='col-md-auto my-auto'>
                        <div className='flex-column justify-content-start'>
                            {/* <div className='row justify-content-start vstack'> */}
                                {
                                    KaiwaMetadata[getKaiwaId(id)].speakers.sort().map((speaker) => (
                                        <div key={id + speaker.code} className='asdf'>
                                            <p className='mb-0'>
                                                <strong>{speaker.code}:&nbsp;</strong> 
                                                {`${speaker.sex} ${speaker.age}`} 
                                                <strong>&emsp;出身: </strong>
                                                {speaker.birthplace} 
                                                <strong>&emsp;居住地: </strong>
                                                {speaker.lived_in.join()}
                                            </p>
                                        </div>
                                    ))
                                }
                            {/* </div> */}
                        </div>

                    </div>
                    <div className='col-md-3'>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="kakari-checkbox"
                                value="kakari"
                                checked={kakariState}
                                onChange={() => setKakariState(!kakariState)}
                            />
                            <label className="form-check-label kakari-style-highlight" htmlFor="kakari-checkbox">係助詞</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="teidai-checkbox"
                                value="teidai"
                                checked={teidaiState}
                                onChange={() => setTeidaiState(!teidaiState)}
                            />
                            <label className="form-check-label teidai-style-highlight" htmlFor="teidai-checkbox">提題助詞</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="kaku-checkbox"
                                value="kaku"
                                checked={kakuState}
                                onChange={() => setKakuState(!kakuState)}
                            />
                            <label className="form-check-label kaku-style-highlight" htmlFor="kaku-checkbox">格助詞</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="sentence-final-checkbox"
                                value="sentence-final"
                                checked={sentenceFinalState}
                                onChange={() => setSentenceFinalState(!sentenceFinalState)}
                            />
                            <label className="form-check-label sentence-final-style-highlight" htmlFor="sentence-final-checkbox">終助詞</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="setsuzoku-checkbox"
                                value="setsuzoku"
                                checked={setsuzokuState}
                                onChange={() => setSetsuzokuState(!setsuzokuState)}
                            />
                            <label className="form-check-label setsuzoku-style-highlight" htmlFor="setsuzoku-checkbox">接続助詞</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="juntai-checkbox"
                                value="juntai"
                                checked={juntaiState}
                                onChange={() => setJuntaiState(!juntaiState)}
                            />
                            <label className="form-check-label juntai-style-highlight" htmlFor="juntai-checkbox">準体助詞</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container'>
                <div className='row'>
                    <table className="table table-hover col">
                        <thead>
                            <tr>
                                <th className="kaiwa-speaker-cell" scope="col"> </th>
                                <th className="kaiwa-okinawan-cell" scope="col">沖縄語</th>
                                <th className="kaiwa-japanese-cell" scope="col">日本語訳</th>
                            </tr>
                        </thead>
                        <tbody className='table-light'>
                            {data && data.map((d) => (
                                <tr>
                                    <td className="kaiwa-speaker-cell">{d.speaker}</td>
                                    <td className="kaiwa-okinawan-cell">{parse(d.html, {
                                        replace: domNode => {
                                            if (domNode.attribs && domNode.attribs.class === 'kakari-style') {
                                                return <span className={kakariState ? 'kakari-style-highlight' : 'kakari-style'}>{domNode.children[0].data}</span>;
                                            }
                                            if (domNode.attribs && domNode.attribs.class === 'teidai-style') {
                                                return <span className={teidaiState ? 'teidai-style-highlight' : 'teidai-style'}>{domNode.children[0].data}</span>;
                                            }
                                            if (domNode.attribs && domNode.attribs.class === 'kaku-style') {
                                                return <span className={kakuState ? 'kaku-style-highlight' : 'kaku-style'}>{domNode.children[0].data}</span>;
                                            }
                                            if (domNode.attribs && domNode.attribs.class === 'sentence-final-style') {
                                                return <span className={sentenceFinalState ? 'sentence-final-style-highlight' : 'sentence-final-style'}>{domNode.children[0].data}</span>;
                                            }
                                            if (domNode.attribs && domNode.attribs.class === 'setsuzoku-style') {
                                                return <span className={setsuzokuState ? 'setsuzoku-style-highlight' : 'setsuzoku-style'}>{domNode.children[0].data}</span>;
                                            }
                                            if (domNode.attribs && domNode.attribs.class === 'juntai-style') {
                                                return <span className={juntaiState ? 'juntai-style-highlight' : 'juntai-style'}>{domNode.children[0].data}</span>;
                                            }
                                        }
                                    })}</td>
                                    <td className='kaiwa-japanese-cell'>{parse(d.jp_translation)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* <table className="table table-hover col">
                    <thead>
                        <tr>
                            <th scope="col">Speaker</th>
                            <th scope="col">Speech</th>
                        </tr>
                    </thead>
                    <tbody className='table-light'>
                        {data && data.map((d) => (
                            <tr>
                                <td>{d.speaker}</td>
                                <td>{parse(d.jp_translation)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table> */}
                </div>
            </div>

        </div>
    )
}
